import { render } from "./breakdown.vue?vue&type=template&id=6cf4a00a&scoped=true"
import script from "./breakdown.vue?vue&type=script&lang=js"
export * from "./breakdown.vue?vue&type=script&lang=js"

import "./breakdown.vue?vue&type=style&index=0&id=6cf4a00a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf4a00a"]])

export default __exports__